import * as React from "react";
import PropTypes from "prop-types";
import DetailsControlWrapper from "nexia_mobile/components/Controls/wrappers/DetailsControlWrapper";
import TileControlWrapper from "nexia_mobile/components/Controls/wrappers/TileControlWrapper";

const CommonControlWrapper = ({ isDetailed, children }) => {
  return isDetailed ? (
    <DetailsControlWrapper>{children}</DetailsControlWrapper>
  ) : (
    <TileControlWrapper>{children}</TileControlWrapper>
  );
};
CommonControlWrapper.propTypes = {
  isDetailed: PropTypes.bool.isRequired,
  children: PropTypes.element,
};

export default CommonControlWrapper;



// WEBPACK FOOTER //
// ./src/components/Controls/wrappers/CommonControlWrapper.jsx